<template>
  <div id="app">


    <div id="nav"  class="is-hidden-touch">
      <!-- TODO スマホの場合最初はナビバー消したいなって-->
      <img id="logo" src="./assets/logo_desktop.png" alt="">
      <router-link to="/">Home</router-link>
      <router-link to="/about">ABOUT</router-link>
      <router-link to="/works">WORKS</router-link>
      <router-link to="/member">MEMBER</router-link>
      <router-link to="/contact">CONTACT</router-link>
      <router-link to="/other">OTHER</router-link>
    </div>


    <nav  v-bind:class="{'is-hidden':$route.path === '/'}" class="navbar is-hidden-desktop is-dark" role="navigation" aria-label="main navigation"  >
      <div class="navbar-brand">
        <a class="navbar-item" href="https://concreate-647bc2.firebaseapp.com">
          <img src=./assets/mini-concreate.png width="112" height="28">
        </a>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample"  class="navbar-menu ">
        <div class="navbar-start  has-text-right ">
          <router-link to="/about">ABOUT</router-link>
          <router-link to="/works">WORKS</router-link>
          <router-link to="/member">MEMBER</router-link>
          <router-link to="/contact">CONTACT</router-link>
          <router-link to="/other">OTHER</router-link>
        </div>

        <div class="navbar-end">
        </div>
      </div>
    </nav>

    <transition name="router-transition">
     <router-view/>
    </transition>

    <canvas class="background"></canvas>
    <vue-particles
            class="background"
            color="#000000"
            :particleOpacity="0.6"
            :particlesNumber="40"
            shapeType="circle"
            :particleSize="3"
            linesColor="#000000"
            :linesWidth="0.2"
            :lineLinked="true"
            :lineOpacity="0.2"
            :linesDistance="175"
            :moveSpeed="1"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
    >
    </vue-particles>
  </div>

</template>

<script>
  import 'bulma/css/bulma.css';
  export default{
    mounted() {
    }
  };

  document.addEventListener('DOMContentLoaded', () => {

    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

      // Add a click event on each of them
      $navbarBurgers.forEach( el => {
        el.addEventListener('click', () => {

          // Get the target from the "data-target" attribute
          const target = el.dataset.target;
          const $target = document.getElementById(target);

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle('is-active');
          $target.classList.toggle('is-active');

        });
      });
    }

  });



</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-feature-settings: "palt";
}
#nav {
  background-color:black;

  display: flex;
  flex-direction: column;

  position:fixed;
  right: 0;
  height: 100%;
  justify-content: center;
  z-index: 1;
}

#nav a {
  font-weight: lighter;
  color: rgb(241, 239, 239);
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  min-width: 200px;
  transition: 0.5s all ease-in-out 0s;
}
#nav a:hover{
  font-weight: lighter;
  background-color: whitesmoke;
  color: black;
}

#nav a.router-link-exact-active {
  color: black;
  background-color: whitesmoke;
  font-size:40px;
  font-weight: lighter;
}
.navbar{
  position: sticky;
  top:0px;

}

.navbar-start{
  display: flex;
  flex-direction: column;
}
  .navbar-start > a{
    padding-right: 10px;
    color: black;
    transition: 1s all ease 0s;
  }
  .navbar-start> .router-link-exact-active{
    color: whitesmoke;
    background-color: gray;
  }
  .title {
    position: sticky;
    font-size: 40px;
    padding-top: 20px;
    margin-left: 20px;
  }

.router-transition-enter-active {
  animation: fadeIn 1s;
  animation-delay: 1.1s;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.router-transition-leave-active {
  animation: fadeOut 1s;
}

@keyframes fadeOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
}
#logo{
  width: 175px;
  position: fixed;
  top:20px;
  padding-left:40px;
}
  .p5Canvas{
    position: fixed;
    top:0px;
    z-index: -1;
  }

html,
body {
  margin: 0;
  padding: 0;
}

canvas {
  position: fixed;
  display: block;
  top: 0;
  left: 0;
  z-index: -1;
}


</style>
